import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from "axios"
import {base_url} from "../../utils/config"
export const user_registered = createAsyncThunk(
  "user/user_registered",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await axios.post(
        `${base_url}/api/register`,
        info,
        {
          withCredentials: true,
        }
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const user_contact = createAsyncThunk(
  "user/user_contact",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    console.log(info)
    try {
      const { data } = await axios.post(
        `${base_url}/api/register-contact`,
        info,
        {
          withCredentials: true,
        }
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


export const authReducer = createSlice({
    name: 'auth',
    initialState: {
        loader: false,
        errorMessage: '',
        successMessage: ''
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = ''
            state.successMessage = ''
        },
        user_reset: (state, _) => {
            state.userInfo = ""
        }
    },
    extraReducers: {
        [user_registered.pending]: (state, _) => {
            state.loader = true
        },
        [user_registered.rejected]: (state, { payload }) => {
            state.errorMessage = payload.message
            state.loader = false
        },
        [user_registered.fulfilled]: (state, { payload }) => {
            state.successMessage = payload.message
            state.loader = false
        },
        [user_contact.pending]: (state, _) => {
            state.loader = true
        },
        [user_contact.rejected]: (state, { payload }) => {
            state.errorMessage = payload.message
            state.loader = false
        },
        [user_contact.fulfilled]: (state, { payload }) => {
            state.successMessage = payload.message
            state.loader = false
        },
        
    }
})

export const { messageClear, user_reset } = authReducer.actions
export default authReducer.reducer